import { vModelText as _vModelText, withKeys as _withKeys, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelCheckbox as _vModelCheckbox, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, vShow as _vShow, createBlock as _createBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "sub_page_con wrap_1120 mypage_apply" }
const _hoisted_2 = { class: "search_wrap" }
const _hoisted_3 = {
  key: 0,
  class: "btn_wrap _default float_right _board_type"
}
const _hoisted_4 = { class: "list_table con_board sub_page_con_view applyLIst" }
const _hoisted_5 = { class: "thead_li" }
const _hoisted_6 = { class: "tr_div con_tit" }
const _hoisted_7 = { class: "tb_chk checkbox_wrap2" }
const _hoisted_8 = {
  key: 0,
  class: "tr_div con_tit"
}
const _hoisted_9 = { class: "tb_chk checkbox_wrap2" }
const _hoisted_10 = ["value", "onClick", "disabled"]
const _hoisted_11 = { class: "tb_no D_only" }
const _hoisted_12 = { class: "tb_board" }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { key: 1 }
const _hoisted_15 = { class: "tb_subject" }
const _hoisted_16 = { class: "tb_activity_date" }
const _hoisted_17 = { class: "tb_condition" }
const _hoisted_18 = { class: "tb_condition" }
const _hoisted_19 = { class: "tb_date_hour" }
const _hoisted_20 = { class: "tb_edit_btn" }
const _hoisted_21 = ["onClick"]
const _hoisted_22 = {
  key: 1,
  class: "tr_div con_tit"
}
const _hoisted_23 = { class: "_flex _cate _ai_b" }
const _hoisted_24 = {
  key: 0,
  class: "condition_tag only_768"
}
const _hoisted_25 = { class: "tb_board" }
const _hoisted_26 = { key: 0 }
const _hoisted_27 = { key: 1 }
const _hoisted_28 = { class: "tb_subject" }
const _hoisted_29 = { class: "_flex _jc_sb _flex_100" }
const _hoisted_30 = { class: "tb_activity_date" }
const _hoisted_31 = { class: "tb_date_hour" }
const _hoisted_32 = ["onClick"]
const _hoisted_33 = { class: "m_option_wrap" }
const _hoisted_34 = ["onClick"]
const _hoisted_35 = ["onClick"]
const _hoisted_36 = {
  key: 1,
  class: "tbody_li no_data"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_PageBtn = _resolveComponent("PageBtn")!
  const _component_ModalDefault = _resolveComponent("ModalDefault")!
  const _component_PaperListModal = _resolveComponent("PaperListModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("section", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _withDirectives(_createElementVNode("input", {
          type: "text",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.state.searchText) = $event)),
          onKeyup: [
            _cache[1] || (_cache[1] = _withKeys(
//@ts-ignore
(...args) => ($setup.getSearch && $setup.getSearch(...args)), ["enter"])),
            _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => ($setup.getSearch && $setup.getSearch(...args)))
          ],
          placeholder: "검색어를 입력하세요."
        }, null, 544), [
          [_vModelText, $setup.state.searchText]
        ]),
        _createElementVNode("button", {
          class: "search_btn icon_wrap",
          onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => ($setup.getSearch && $setup.getSearch(...args)))
        }, [...(_cache[10] || (_cache[10] = [
          _createElementVNode("img", {
            src: "img/search_btn.png",
            alt: ""
          }, null, -1)
        ]))])
      ]),
      (!$setup.state.isMobile)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("button", {
              class: "common_btn _gray",
              onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => ($setup.isDelete && $setup.isDelete(...args)))
            }, "삭제")
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("ul", null, [
          _createElementVNode("li", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _withDirectives(_createElementVNode("input", {
                  type: "checkbox",
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (($setup.state.checkAll) = $event)),
                  onChange: _cache[6] || (_cache[6] = ($event: any) => ($setup.toggleAll()))
                }, null, 544), [
                  [_vModelCheckbox, $setup.state.checkAll]
                ]),
                _cache[11] || (_cache[11] = _createElementVNode("em", null, null, -1))
              ]),
              _cache[12] || (_cache[12] = _createStaticVNode("<div class=\"tb_no D_only\" data-v-722a12ef>번호</div><div class=\"tb_board\" data-v-722a12ef>게시판</div><div class=\"tb_subject\" data-v-722a12ef>제목</div><div class=\"tb_activity_date\" data-v-722a12ef>활동기간</div><div class=\"tb_condition\" data-v-722a12ef>상태</div><div class=\"tb_condition\" data-v-722a12ef>결과</div><div class=\"tb_date_hour\" data-v-722a12ef>신청날짜</div><div class=\"tb_edit_btn\" data-v-722a12ef>수정</div>", 8))
            ])
          ]),
          ($setup.state.list.length > 0)
            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList($setup.state.list, (item, index) => {
                return (_openBlock(), _createElementBlock("li", {
                  class: "tbody_li active",
                  key: index
                }, [
                  (!$setup.state.isMobile)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                        _createElementVNode("div", _hoisted_9, [
                          _withDirectives(_createElementVNode("input", {
                            type: "checkbox",
                            name: "chk",
                            value: item.idx,
                            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (($setup.state.checkedList) = $event)),
                            onClick: ($event: any) => ($setup.toggle(item)),
                            disabled: item.boardVO.state !== 2 || item.state === 2
                          }, null, 8, _hoisted_10), [
                            [_vModelCheckbox, $setup.state.checkedList]
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_11, _toDisplayString(($setup.state.page - 1) * $setup.state.size + (index + 1)), 1),
                        _createElementVNode("div", _hoisted_12, [
                          (item.boardVO.type === 1)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_13, "반성매매 시민활동"))
                            : (item.boardVO.type === 2)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_14, "캠페인·이벤트"))
                              : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("div", _hoisted_15, [
                          _createVNode(_component_router_link, {
                            to: { name: item.boardVO.type === 1 ? 'ActivityView' : 'EventView', params: { id: item.boIdx } },
                            class: "elips_1"
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("u", null, _toDisplayString(item.boardVO.title), 1)
                            ]),
                            _: 2
                          }, 1032, ["to"])
                        ]),
                        _createElementVNode("div", _hoisted_16, [
                          _cache[13] || (_cache[13] = _createElementVNode("span", { class: "mo_th" }, "활동기간", -1)),
                          _createTextVNode(" " + _toDisplayString($setup.CommonUtils.dateFormatYY(new Date(item.boardVO.activeStartDate), ".")) + " - " + _toDisplayString($setup.CommonUtils.dateFormatYY(new Date(item.boardVO.activeStartDate), ".")), 1)
                        ]),
                        _createElementVNode("div", _hoisted_17, [
                          _cache[14] || (_cache[14] = _createElementVNode("span", { class: "mo_th" }, "상태", -1)),
                          _createTextVNode(" " + _toDisplayString(item.boardVO.state === 1 ? "대기" : item.boardVO.state === 2 ? "모집중" : "마감"), 1)
                        ]),
                        _createElementVNode("div", _hoisted_18, [
                          _cache[15] || (_cache[15] = _createElementVNode("span", { class: "mo_th" }, "결과", -1)),
                          _createTextVNode(" " + _toDisplayString(item.state === 2 ? "선정" : "미선정"), 1)
                        ]),
                        _createElementVNode("div", _hoisted_19, [
                          _cache[16] || (_cache[16] = _createElementVNode("span", { class: "mo_th" }, "신청날짜", -1)),
                          _createTextVNode(" " + _toDisplayString($setup.CommonUtils.dateFormat(new Date(item.createDate), ".", true)), 1)
                        ]),
                        _createElementVNode("div", _hoisted_20, [
                          _createElementVNode("button", {
                            class: "blue_btn",
                            onClick: ($event: any) => ($setup.showAnswer(item))
                          }, _toDisplayString(item.boardVO.state === 2 && item.state === 1 ? "수정" : "보기"), 9, _hoisted_21)
                        ])
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_22, [
                        _createElementVNode("div", _hoisted_23, [
                          _createElementVNode("div", {
                            class: _normalizeClass(["condition_tag only_768", item.boardVO.state === 1 || item.boardVO.state === 2 ? '_green' : '_gray'])
                          }, _toDisplayString(item.boardVO.state === 1 ? "대기" : item.boardVO.state === 2 ? "모집중" : "마감"), 3),
                          (item.boardVO.state === 3)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_24, _toDisplayString(item.state === 2 ? "선정" : "미선정"), 1))
                            : _createCommentVNode("", true),
                          _createElementVNode("div", _hoisted_25, [
                            (item.boardVO.type === 1)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_26, "반성매매 시민활동"))
                              : (item.boardVO.type === 2)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_27, "캠페인·이벤트"))
                                : _createCommentVNode("", true)
                          ]),
                          _cache[17] || (_cache[17] = _createElementVNode("div", { class: "_flex p_r_15" }, null, -1))
                        ]),
                        _createElementVNode("div", _hoisted_28, [
                          _createVNode(_component_router_link, {
                            to: { name: item.boardVO.type === 1 ? 'ActivityView' : 'EventView', params: { id: item.boIdx } },
                            class: "elips_1"
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("u", null, _toDisplayString(item.boardVO.title), 1)
                            ]),
                            _: 2
                          }, 1032, ["to"])
                        ]),
                        _createElementVNode("div", _hoisted_29, [
                          _createElementVNode("div", _hoisted_30, [
                            _cache[18] || (_cache[18] = _createElementVNode("span", { class: "mo_th" }, "활동기간", -1)),
                            _createTextVNode(" " + _toDisplayString($setup.CommonUtils.dateFormatYY(new Date(item.boardVO.activeStartDate), ".")) + " - " + _toDisplayString($setup.CommonUtils.dateFormatYY(new Date(item.boardVO.activeStartDate), ".")), 1)
                          ]),
                          _createElementVNode("div", _hoisted_31, [
                            _cache[19] || (_cache[19] = _createElementVNode("span", { class: "mo_th" }, "신청날짜", -1)),
                            _createTextVNode(" " + _toDisplayString($setup.CommonUtils.dateFormatForMobile(new Date(item.createDate), ".", true)), 1)
                          ])
                        ]),
                        _createElementVNode("button", {
                          class: "m_option_btn icon_wrap only_768",
                          onClick: ($event: any) => ($setup.optionOpen(item))
                        }, [...(_cache[20] || (_cache[20] = [
                          _createElementVNode("img", {
                            src: "img/kebabIcon.png",
                            class: ""
                          }, null, -1)
                        ]))], 8, _hoisted_32),
                        _withDirectives(_createElementVNode("div", _hoisted_33, [
                          _createElementVNode("button", {
                            type: "button",
                            onClick: ($event: any) => ($setup.showAnswer(item))
                          }, _toDisplayString(item.boardVO.state === 2 && item.state === 1 ? "수정" : "보기"), 9, _hoisted_34),
                          (item.boardVO.state < 3)
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 0,
                                type: "button",
                                class: "_gray",
                                onClick: ($event: any) => ($setup.optionClose(item))
                              }, "삭제", 8, _hoisted_35))
                            : _createCommentVNode("", true)
                        ], 512), [
                          [_vShow, $setup.state.isShowBtn && $setup.state.list_idx === item.idx]
                        ])
                      ]))
                ]))
              }), 128))
            : (_openBlock(), _createElementBlock("li", _hoisted_36, [...(_cache[21] || (_cache[21] = [
                _createElementVNode("div", { class: "tr_div" }, [
                  _createElementVNode("div", {
                    class: "tb_subject",
                    style: {"text-align":"center","width":"100%"}
                  }, "등록된 게시물이 없습니다.")
                ], -1)
              ]))]))
        ])
      ]),
      ($setup.state.list.length !== 0)
        ? (_openBlock(), _createBlock(_component_PageBtn, {
            key: 1,
            currentPage: $setup.state.page,
            totalLength: $setup.state.totalLength,
            perPage: $setup.state.size,
            onOnPaging: $setup.handlePageChange
          }, null, 8, ["currentPage", "totalLength", "perPage", "onOnPaging"]))
        : _createCommentVNode("", true),
      ($setup.state.isShowModal)
        ? (_openBlock(), _createBlock(_component_ModalDefault, {
            key: 2,
            type: $setup.state.modalTab,
            title: $setup.state.modalTitle,
            content: $setup.state.modalContent,
            textarea1: $setup.state.textarea1,
            textarea2: $setup.state.textarea2,
            isAgree: $setup.state.isAgree,
            isPossible: $setup.state.isPossible,
            onClose: $setup.closeModal,
            onCallback: $setup.callBackModal
          }, null, 8, ["type", "title", "content", "textarea1", "textarea2", "isAgree", "isPossible", "onClose", "onCallback"]))
        : _createCommentVNode("", true)
    ]),
    ($setup.state.isShowAnswer)
      ? (_openBlock(), _createBlock(_component_PaperListModal, {
          key: 0,
          answerInfo: $setup.state.answerInfo,
          isPossible: $setup.state.isPossible,
          onClose: _cache[8] || (_cache[8] = ($event: any) => ($setup.state.isShowAnswer = false)),
          onCallback: _cache[9] || (_cache[9] = ($event: any) => {
            $setup.state.isShowAnswer = false;
            $setup.getApplyList();
        })
        }, null, 8, ["answerInfo", "isPossible"]))
      : _createCommentVNode("", true)
  ], 64))
}